export const SET_AUTH = 'authResolve';
export const CONFIRM_AUTH = 'authConfirm';
export const PURGE_AUTH = 'logout';

export const SET_SIDEBAR_COLLAPSE = 'collapseSidebar';
export const SET_SIDEBAR_HIDE = 'hideSidebar';
